var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-v2"},[_c('div',{staticClass:"staff-grid-v2"},_vm._l((_vm.staffList),function(item){return _c('router-link',{key:item.id,staticClass:"staff-item-v2",attrs:{"to":'/enterprise/staff/' + item.id}},[_c('img',{attrs:{"src":item.image,"alt":item.title}}),_c('span',[_vm._v(_vm._s(item.title))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }